export const Hero = () => {
  return (
    <section className="pt-16 pb-20 md:pt-24 md:pb-32 border-b border-stone-300 bg-[#faf9f5]" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl anim-reveal">
          <div className="font-mono text-xs uppercase tracking-widest text-emerald-800 mb-4 flex items-center space-x-2">
            <span>&#9670;</span>
            <span>Pedagogy &amp; Tournament Excellence</span>
          </div>

          <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl uppercase tracking-tight text-emerald-950 leading-[0.92] mb-8" data-testid="hero-headline">
            Master Strategy From Square One
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 pt-4 anim-reveal-late">
            <div className="md:col-span-8">
              <p className="text-xl sm:text-2xl font-light text-stone-800 leading-snug" data-testid="hero-subcopy">
                Small batches. Personal attention for every student. Coached by FIDE-rated mentors
                who compete nationally and turn beginners of any age into state-level medalists.
              </p>
            </div>
            <div className="md:col-span-4 flex flex-col justify-end">
              <a
                href="#contact"
                data-testid="hero-trial-cta"
                className="w-full inline-flex items-center justify-center px-6 py-4 rounded bg-emerald-950 text-white font-mono text-xs uppercase tracking-widest hover:bg-emerald-900 transition-colors shadow-sm"
              >
                Book Evaluation Trial &rarr;
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
